'use strict';
const angular = require('angular');

export class postEditComponent {
  constructor(StorageService, $uibModal, Auth) {
    'ngInject';

    this.StorageService = StorageService;
    this.$uibModal = $uibModal;
    this.Auth = Auth;

    this.toolbarDefinition = [
      ["bold","italics","underline","strikeThrough"],
      ["p","pre","quote","clear"],
      ["ul","ol"],
      ["undo","redo"],
      ["insertLink"]
    ];
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.post) {
      this.type = 'Post';
      this.data = this.config.post;
    } else if (this.config.message) {
      this.type = 'Message';
      this.data = this.config.message;
    }
  };

  ok() {
    this.close({$value: this.data});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  checkValidity() {

    if (this.type == 'Post' && (this.data.title && this.data.contents))
      return true;
    else if (this.type == 'Message' && this.data.contents)
      return true;

    return false;
  }

  removeAsset(idx) {
    this.data.attachments.splice(idx,1);
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  openAssetBrowserModal() {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetBrowser',
      resolve: {
        config: function() {
          return {
            restrictToUserAssets: !that.Auth.isAdminSync(),
            userId: that.Auth.getCurrentUserSync()._id
          }
        }
      },
      size: 'lg'
    });

    modalInstance.result.then(
      function (newlySelectedAssets) {
        that.data.attachments = that.data.attachments.concat(newlySelectedAssets);
      },
      function () { /* cancel */ }
    );

  }

  openAssetUploadModal = function () {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'assetUpload',
      resolve: {
        config: function() {
          return {
            acceptedFileTypes: 'application/pdf,image/*'
          }
        }
      }
    });

    modalInstance.result.then(
      function (result) {

        result.forEach(storageId => {
          that.StorageService.getMeta({id: storageId}, data => {
            that.data.attachments.push(data);
          }, err => {
            console.log('could not retrieved storage from server');
          });

        });

      },
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduApp.postEdit', [])
  .component('postEditor', {
    template: require('./post-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: postEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/forum/edit/post-edit.component.js